import { rsimSubscriptionStatusFilterAtom } from 'src/atoms/filters/rsim-products';
import { SubscriptionStatusSelect } from 'src/common/components/SubscriptionStatus/SubscriptionStatusSelect';

export const RSimSubscriptionStatusSelect = () => {
  return (
    <SubscriptionStatusSelect subscriptionStatusesFilterAtom={rsimSubscriptionStatusFilterAtom} />
  );
};
